import { render, staticRenderFns } from "./dictionaryDetail.vue?vue&type=template&id=190cab10&scoped=true&"
import script from "./dictionaryDetail.vue?vue&type=script&lang=js&"
export * from "./dictionaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190cab10",
  null
  
)

export default component.exports